import React from 'react';
import { Chip, alpha, Theme } from '@mui/material';
import { SelectOption } from '../components/common/SearchableSelect';
import { Session } from '../types/sessions';

/**
 * Build SearchableSelect options for a list of sessions, marking the
 * active session with a subtle green "Active" chip. Used across the fee
 * module so every session picker reads the same way as Enrollments.
 */
export const buildSessionOptions = (sessions: Session[], theme: Theme): SelectOption[] =>
  sessions.map((s) => ({
    value: s._id,
    label: s.name,
    badge: s.status === 'active'
      ? (
        <Chip
          label="Active"
          size="small"
          variant="outlined"
          sx={{
            height: 20,
            fontSize: '0.68rem',
            fontWeight: 600,
            borderColor: alpha(theme.palette.success.main, 0.32),
            color: theme.palette.success.dark,
            bgcolor: alpha(theme.palette.success.main, 0.10),
            '& .MuiChip-label': { px: 0.9 },
          }}
        />
      )
      : undefined,
  }));
